import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import { Table } from 'react-bootstrap';


import { expectedTicketNumberSet } from '../actions';
import MissingTicketNumberRow from './MissingTicketNumberRow';


const propTypes = exact({
  missingTicketNumbers: PropTypes.array.isRequired,
  expectedTicketNumberSetAction: PropTypes.func.isRequired,
});


const MissingTicketNumbersTable = (props) => {
  const { expectedTicketNumberSetAction } = props;

  const renderMissingTicketNumberRow = (missingTicketNumber) => {
    const {
      id,
      ticketNumber,
      expected,
      reason,
    } = missingTicketNumber;

    const handleExpectedToggle = async (reasonInput) => {
      await expectedTicketNumberSetAction(id, !expected, reasonInput);
    };

    return (
      <MissingTicketNumberRow
        key={id}
        ticketNumber={ticketNumber}
        expected={expected}
        reason={reason}
        handleExpectedToggle={handleExpectedToggle}
      />
    );
  };

  const { missingTicketNumbers } = props;
  return (
    <Table striped>
      <thead>
        <tr>
          <td>Ticket Number</td>
          <td>State</td>
          <td>Reason</td>
          <td />
        </tr>
      </thead>
      <tbody>
        {missingTicketNumbers.map(renderMissingTicketNumberRow, this)}
      </tbody>
    </Table>
  );
};


MissingTicketNumbersTable.propTypes = propTypes;


const mapDispatchToProps = {
  expectedTicketNumberSetAction: expectedTicketNumberSet,
};


const withRedux = connect(null, mapDispatchToProps);


const withHide = branch(
  (props) => { return props.missingTicketNumbers === null; },
  renderNothing,
);


const enhance = compose(
  withHide,
  withRedux,
);


export default enhance(MissingTicketNumbersTable);
